import { MemberProps } from 'app/components/Core/convention'
import KDatePicker from 'app/components/Modules/Form/KDatePicker'
import KForm from 'app/components/Modules/Form/KForm'
import KInputText from 'app/components/Modules/Form/KInputText'
import KTextArea from 'app/components/Modules/Form/KTextArea'
import { KFormProps, RecordType } from 'app/constants/GlobalTypes'

const Form: React.FC<MemberProps<IDamageInfo, KFormProps<IDamageInfo>>> = ({
  member,
  props: { onSuccess }
}) => {
  return (
    <KForm
      inlineErrors
      recordId={member?.id}
      onSuccess={onSuccess}
      recordType={RecordType.damage_info}
      portalId="modal-footer"
      layout="vertical">
      <KTextArea name="description" readOnly />
      <KDatePicker name="damage_time" showTime />
      <KInputText name="perpetrator" />
      <KTextArea rows={4} name="damage_circumstances" />
    </KForm>
  )
}

export default Form
